<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/q74Ec4/tc-custom/9781453239056.jpg?1733100025193" alt="This image is the cover for the book Finnegan's Week"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Finnegan's Week
      </h1>
      <p class="bookDescription body article font2">
        <b>A toxic spill causes a lethal chain reaction for a San Diego cop in this “very funny” <i>New York Times</i> bestseller by the author of <i>The Choirboys</i> (<i>Kirkus Reviews</i>).</b><br/><br/> Fin Finnegan, a San Diego police detective and wannabe actor heading straight for a midlife meltdown, is assigned a routine truck theft that turns into a toxic chemical spill, setting off a bizarre chain reaction of death and murder on both sides of the Mexican border. Fin is forced to team up with Nell Salter, a sexy female investigator, as well as an equally fetching US Navy investigator who wants to learn all that Fin can teach her—and that’s saying a lot. The<i> New York Times Book Review</i> called it “a frolic, a joy, a hoot, a riot of a book.” And <i>Entertainment Weekly</i> said, “superbly crafted and paced, deliciously funny, but fundamentally, as always, deadly serious.”
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Wambaugh
      </h2>
      
      <p class="authorDescription body article">The son of a policeman, Joseph Wambaugh (b. 1937) began his writing career while a member of the Los Angeles Police Department. He joined the LAPD in 1960 after three years in the Marine Corps, and rose to the rank of detective sergeant before retiring in 1974. His first novel, <i>The New Centurions</i> (1971), was a quick success, drawing praise for its realistic action and intelligent characterization, and was adapted into a feature film starring George C. Scott. He followed it up with <i>The Blue Knight</i> (1972), which was adapted into a mini-series starring William Holden and Lee Remick.&#160;Since then Wambaugh has continued writing about the LAPD. He has been credited with a realistic portrayal of police officers, showing them not as superheroes but as men struggling with a difficult job, a depiction taken mainstream by television&rsquo;s <i>Police Story</i>, which Wambaugh helped create in the mid-1970s. In addition to novels, Wambaugh has written nonfiction, winning a special Edgar Award for 1974&rsquo;s <i>The Onion Field</i>, an account of the longest criminal trial in California history. His most recent work is the novel <i>Hollywood Moon</i> (2010). <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a87205c